import { render, staticRenderFns } from "./yleiset-ehdot.vue?vue&type=template&id=3bf4b4d0&"
import script from "./yleiset-ehdot.vue?vue&type=script&lang=js&"
export * from "./yleiset-ehdot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports